import { combineReducers } from 'redux'

import settings from './settings'

export const reducer = combineReducers({
  settings: settings.reducer,
})

export default reducer
